import { scroll } from "./scroll";
import { humanDate } from "./humanDate";
import { preview } from "./preview";
import { notify } from "./notify";
import { request } from "./request";
import { fetchNews } from "./fetchNews";
import { fetchItems } from "./fetchItems";
import { fetchMedia } from "./fetchMedia";
import { dimmer } from "./dimmer";
import { cModal } from "./modal";
import { parseTerms } from "./parseTerms";
import { uniqueList } from "./uniqueList";
import { playButton } from "./playButton";
import { binaryUpload } from "./binaryUpload";
import { lang, assetHost, status, s3bucket } from "../app";
// library imports

let kits = [];
export const buildKitEditor = async (kitButton, _kits, id = null, editLang = "en", author, userLevel, cb) => {
	kits = _kits;
	const admin = userLevel.toLowerCase() === "admin";
	let damAssets = {
		image: [],
		video: [],
		pdf: []
	};
	try {
		const response = await fetchMedia(
			{
				terms: "ag:newsroom usage:{Media Kit}",
				// asset group: newsroom; usage: Media Kit
				expand: "all"
			},
			[],
			true
		);
		if (response.length) {
			response.sort((a, b) => {
				const aVal = new Date(a.security.release_date).getTime();
				const bVal = new Date(b.security.release_date).getTime();
				return aVal < bVal ? 1 : aVal > bVal ? -1 : 0;
			});
			response
				.map(item => ({
					id: item.id,
					file_properties: item.file_properties,
					metadata: item.metadata,
					thumbnails: item.thumbnails,
					filename: item.filename,
					file_upload_date: item.file_upload_date,
					embeds: item.embeds
				}))
				.forEach(item => {
					if (damAssets[item.file_properties.format_type]) {
						damAssets[item.file_properties.format_type].push(item);
					} else {
						damAssets[item.file_properties.format_type] = [item];
					}
				});
		}
	} catch (err) {
		console.error(err);
		notify("Error fetching DAM assets", "danger");
	}
	// fetch and sort DAM assets

	kitButton
		.text("Cancel Media Kit")
		.off("click")
		.on("click", function (e) {
			e.preventDefault();
			id = "";
			$(this)
				.text("Create Media Kit")
				.off("click")
				.on("click", function (e, data) {
					e.preventDefault();
					$("#kit_editor_wrapper").html("");
					buildKitEditor($(this), kits, data && data.id ? data.id : id, editLang, author, userLevel, cb);
				});
			// restore click handler to presentEditor
			// and update button label

			$("#kit_editor_wrapper").html("").addClass("hidden");
			// clear editor
		});
	// update kit button

	let kit,
		terms = [],
		editValues,
		now = new Date().getTime(),
		foundReleases = [],
		defaults = {
			created: now,
			name: "",
			releases: [],
			images: [],
			videos: [],
			docs: [],
			thumb: "",
			lang: "en",
			pubTime: now,
			status: false,
			updated: now,
			createdBy: author,
			sortIndex: 0
		};
	if (id) {
		kit = kits.find(item => item.id === id);
		// kit now is the id'd kit's global values
	} else {
		let values = {};
		for (let key in defaults) {
			values[key] = defaults[key];
		}
		kit = {
			langs: {
				[editLang]: values
			},
			type: "kit"
		};
	}
	// if new kit, this 'kit' object is for storing
	// form values between lang changes

	// MARK: Kit editor
	if (!kit.langs[editLang]) {
		kit.langs[editLang] = Object.assign(JSON.parse(JSON.stringify(defaults)), {
			lang: editLang
		});
		if (kit.id) {
			id = kit.id;
		}
		if (id) {
			kit.id = id;
			kit.langs[editLang].id = id;
		}
		// editValues now holds this kit's lang-based values;
		// if this is the first kit for this lang, values
		// are set to defaults
	}
	editValues = kit.langs[editLang];
	if (editValues.releases.length) {
		const response = await fetchItems(editValues.releases, "release", kitButton, admin);
		foundReleases = response
			.sort((a, b) => {
				a = a.langs[lang].pubTime;
				b = b.langs[lang].pubTime;
				return a < b ? 1 : a > b ? -1 : 0;
			})
			.map(item => ({
				id: item.id,
				headline: item.langs[editLang].headline,
				pubTime: item.langs[editLang].pubTime,
				status: item.langs[editLang].status,
				images: item.langs[editLang].images
			}));
	}

	let kitEditor = $(`<div id="kit_editor">
            <div data-wrapper="form wrapper">
                    <form data-lang="${editLang}" class="uk-inline" id="kit_form" name="kit_form" enctype="multipart/form-data" autocomplete="off"></form>                    
            </div>
        </div>`);
	// instantiate kit editor

	$("#kit_editor_wrapper").html(kitEditor).removeClass("hidden");
	scroll(kitEditor, 200);
	now = new Date().getTime();
	let pubTime = id ? editValues.pubTime : now;
	let form = kitEditor.find("#kit_form");

	form.append(`<div uk-grid class="uk-grid-small">
					${id ? `<div class="text-grey5">ID: ${id}</div>` : ""}
                    <div class="uk-width-1-1 bold uk-padding-remove-vertical">1. Basic information</div>
                    <div field="name" class="field uk-width-1-1 uk-width-1-4@s uk-padding-remove-vertical">
                        <label for="name">Name</label>
                        <input class="uk-input" name="name" type="text" value="${editValues.name ? editValues.name : ""}" placeholder="Kit name">
                    </div>
                    <div class="field uk-width-1-1 uk-width-1-4@s uk-padding-remove-vertical">
                        <label for="created">Created</label>
                        <input class="uk-input" name="createdReadable" data-timestamp="${editValues.created ? editValues.created : now}" type="text" disabled value="${id ? humanDate(editValues.created, true, " at ") : humanDate(now, true, " at ")}">
                    </div>
                    <div class="field uk-width-1-1 uk-width-1-4@s  uk-padding-remove-vertical">
                        <label for="pubDate">Publish time</label>
                        <input class="uk-input" type="date" value="${pubTime}" name="pubTime">
                    </div>
                    <div class="field uk-width-1-4@s  uk-padding-remove-vertical">
                        <div class="uk-flex uk-flex-around">
                            <div>
                                <label for="status">Active</label>
                                <input class="uk-checkbox" name="status" type="checkbox" value=${editValues.status ? editValues.status : false}>
                            </div>
                        </div>
                    </div>
                    <div class="separator center ruled uk-width-1-1"></div>
                    <div field="releases" class="uk-width-1-1 bold  uk-padding-remove-vertical">2. News Releases</div>
                    <div id="release_search" class="field uk-width-1-1 uk-width-1-2@s  uk-padding-remove-vertical">
                        <label for="search">Release Search</label>
                        <div class="uk-flex">
                            <input class="uk-input uk-margin-small-right" name="search" type="text" placeholder="Keywords or phrases">
                            <button id="release_search_button" tab-index="0" class="uk-button uk-button-primary">Search</button>
                        </div>
                    </div>
                    <div id="release_select" class="${editValues.releases.length ? "" : "hidden"} field uk-width-1-1 uk-width-1-2@s">
                        <label>Select Releases<span id="release_count"></span>:
							<div class="uk-text-small uk-margin-=small-top"><span class="inactive"></span>—Not active <span class="unpublished"></span>—Future Publish Date</span></div>
						</label>
                        <div id="all_releases_wrapper" class="uk-padding-small">							
                            <div id="selected_releases_wrapper" ${editValues.releases.length ? "" : `class="hidden"`}>
                                <label>Drag and drop selected releases to sort</label>
                                <div uk-sortable id="selected_releases_container"></div>
                            </div>
                            <div id="found_releases"></div>
							
                        </div>
                    </div>
                    <div class="separator center ruled uk-width-1-1"></div>

					<ul uk-accordion>
						<li>
							<a field="images" class="uk-accordion-title bold" href>3. Images (${damAssets.image.length} available; <span id="image-grid-sel-ct">0</span> selected)</a>
							<div class="uk-accordion-content">
								<div class="uk-text-small uk-margin-small-bottom">Don't see an image you need? Images here are hosted in the DAM, assigned to the "Newsroom Assets Group" with their <span class="italic">Usage</span> property assigned to "Media Kit".</div>
								<div class="field uk-width-1-1 uk-width-1-3@s">
									<input type="text" class="uk-input asset-filter" data-type="image" id="image-filter" name="image-filter" placeholder="Enter terms to filter images"/>
								</div>													
								<div id="image-grid" uk-sortable class="uk-margin-small-top uk-padding-remove-left">
									${
										damAssets.image.length
											? damAssets.image
													.map(
														item => `<div class="card-container" data-id="${item.id}">
											<div class="uk-card uk-card-hover uk-card-default uk-card-small breakable">
												<div class="image-wrapper uk-card-media-top">
													<img data-expires="${item.thumbnails["600px"].valid_until}" src="${item.thumbnails["600px"].url}"/>
													<span data-type="image" data-id="${item.id}" class="asset-preview-btn pointer" uk-icon="icon: search; ratio: .8"></span>													
												</div>
												<div class="uk-card-header">
													<div class="uk-text-small">Newsroom Display Name</div>
													<p class="bold">${item.metadata && item.metadata.fields && item.metadata.fields.newsroomDisplayName && item.metadata.fields.newsroomDisplayName.length ? item.metadata.fields.newsroomDisplayName[0] : "Not provided"}</p>
													<div class="uk-text-small">DAM Filename</div>
													<p class="bold">${item.filename}</p>																					
												</div>
												<div class="uk-card-body">	
													<p><span class="bold">Uploaded: </span> ${humanDate(new Date(item.file_upload_date).getTime())}</p>
													<p><span class="bold">File size: </span> ${item.file_properties.size_in_kbytes} KB</p>
													<p><span class="bold">Image size: </span> ${item.file_properties.image_properties.width}px x ${item.file_properties.image_properties.height}px</p>
													<p><span class="bold">Format: </span> ${item.file_properties.format.toLowerCase()}</p>
												</div>
											</div>
										</div>`
													)
													.join("")
											: `No images found in the Newsroom Assets Group with "Usage" assigned to "Media Kit"`
									}
								</div>	
							</div>				
	                    </li>
						<li>
							<a field="videos" class="uk-accordion-title bold" href>4. Videos (${damAssets.video.length} available; <span id="video-grid-sel-ct">0</span> selected)</a>
							<div class="uk-accordion-content">
								<div class="uk-text-small uk-margin-small-bottom">Don't see a video you need? Videos here are hosted in the DAM, assigned to the "Newsroom Assets Group" with their <span class="italic">Usage</span> property assigned to "Media Kit".</div>
								<div class="field uk-width-1-1 uk-width-1-3@s">
									<input type="text" class="uk-input asset-filter" data-type="video" id="video-filter" name="video-filter" placeholder="Enter terms to filter videos"/>
								</div>						
								<div id="video-grid" uk-sortable class="uk-margin-small-top uk-padding-remove-left">
									${
										damAssets.video.length
											? damAssets.video
													.map(
														item => `<div class="card-container" data-id="${item.id}">
											<div class="uk-card uk-card-hover uk-card-default uk-card-small breakable">
												<div class="image-wrapper uk-card-media-top">
													<img data-expires="${item.thumbnails["600px"].valid_until}" src="${item.thumbnails["600px"].url}"/>
													${playButton()}
													<span data-type="video" data-id="${item.id}" class="asset-preview-btn pointer" uk-icon="icon: search; ratio: .8"></span>
												</div>
												<div class="uk-card-header">
													<div class="uk-text-small">Newsroom Display Name</div>
													<p class="bold">${item.metadata && item.metadata.fields && item.metadata.fields.newsroomDisplayName && item.metadata.fields.newsroomDisplayName.length ? item.metadata.fields.newsroomDisplayName[0] : "Not provided"}</p>
													<div class="uk-text-small">DAM Filename</div>
													<p class="bold">${item.filename}</p>																					
												</div>
												<div class="uk-card-body">	
													<p><span class="bold">Uploaded: </span> ${humanDate(new Date(item.file_upload_date).getTime())}</p>
													<p><span class="bold">File size: </span> ${item.file_properties.size_in_kbytes} KB</p>
													<p><span class="bold">Video length: </span> ${item.file_properties.video_properties.duration} seconds</p>
													<p><span class="bold">Format: </span> ${item.file_properties.format.toLowerCase()}</p>
												</div>
											</div>
										</div>`
													)
													.join("")
											: `No videos found in the Newsroom Assets Group with "Usage" assigned to "Media Kit"`
									}
								</div>
							</div>
						</li>
						<li>	
			                <a field="docs" class="uk-accordion-title bold" href>5. Documents (${damAssets.pdf.length} available; <span id="document-grid-sel-ct">0</span> selected)</a>
							<div class="uk-accordion-content">
								<div class="uk-text-small uk-margin-small-bottom">Don't see a document you need? Documents here are hosted in the DAM, assigned to the "Newsroom Assets Group" with their <span class="italic">Usage</span> property assigned to "Media Kit".</div>
								<div class="field uk-width-1-1 uk-width-1-3@s">
									<input type="text" class="uk-input asset-filter" data-type="document" id="document-filter" name="document-filter" placeholder="Enter terms to filter documents"/>
								</div>															
								<div id="document-grid" uk-sortable class="uk-margin-small-top uk-padding-remove-left">
									${
										damAssets.pdf.length
											? damAssets.pdf
													.map(
														item => `<div class="card-container" data-id="${item.id}">
											<div class="uk-card uk-card-hover uk-card-default uk-card-small breakable">
												<div class="image-wrapper uk-card-media-top">
													<img data-expires="${item.thumbnails["600px"].valid_until}" src="${item.thumbnails["600px"].url}"/>	
													<span data-type="pdf" data-id="${item.id}" class="asset-preview-btn pointer" uk-icon="icon: search; ratio: .8"></span>									
												</div>
												<div class="uk-card-header">
													<div class="uk-text-small">Newsroom Display Name</div>
													<p class="bold">${item.metadata && item.metadata.fields && item.metadata.fields.newsroomDisplayName && item.metadata.fields.newsroomDisplayName.length ? item.metadata.fields.newsroomDisplayName[0] : "Not provided"}</p>
													<div class="uk-text-small">DAM Filename</div>
													<p class="bold">${item.filename}</p>																					
												</div>
												<div class="uk-card-body">	
													<p><span class="bold">Uploaded: </span> ${humanDate(new Date(item.file_upload_date).getTime())}</p>
													<p><span class="bold">File size: </span> ${item.file_properties.size_in_kbytes} KB</p>
													<p><span class="bold">Format: </span> ${item.file_properties.format.toLowerCase()}</p>
												</div>
											</div>
										</div>`
													)
													.join("")
											: `No documents found in the Newsroom Assets Group with "Usage" assigned to "Media Kit"`
									}
								</div>
							</div>
						</li>
					</ul>
                    <div class="separator center ruled uk-width-1-1"></div>
                    <div field="thumb" class="uk-width-1-1 bold uk-padding-remove-vertical">6. Thumbnail selection
						<div class="uk-text-small">Thumbnail options will appear here as you make release, image, video or document selections above</div>
					</div>
					<div id="thumb_picker" uk-grid class="uk-width-1-1 uk-grid-small uk-padding-remove-left uk-margin-small-top uk-grid-child-width-1-1 uk-grid-child-width-1-6@s"></div>                    
                </div>
                <div class="separator center ruled uk-width-1-1"></div>
                <div>
                    <button id="submitkitButton" class="button uk-button uk-button-primary">Save Media Kit</button>
                    ${id ? `<button id="deletekitButton" class="button uk-button uk-button-danger uk-align-right">Delete Media Kit</button>` : ""}
                </div>`);
	// instantiate media kit form

	const updateSelected = grid => {
		grid.find(".card-container.selected").removeClass("selected");
		const gridId = grid.attr("id");
		const srcType = gridId === "image-grid" ? "image" : gridId === "video-grid" ? "video" : "pdf";
		const assetType = srcType === "image" ? "images" : srcType === "video" ? "videos" : "docs";
		let assets = editValues[assetType];
		const removals = [];
		if (assets.length) {
			assets.forEach((asset, index) => {
				const assetContainer = grid.find(`.card-container[data-id='${asset.id}']`);
				if (assetContainer.length) {
					assetContainer.addClass("selected").insertBefore(grid.children().eq(index));
				} else {
					removals.push(asset.id);
					notify(`Could not find <span class="bold">${asset.filename} in DAM collection; removing from Kit`, "danger");
				}
			});
			if (removals.length) {
				removals.forEach(id => {
					assets = assets.filter(item => item.id != id);
				});
				editValues[assetType] = assets;
			}
		}
		$(`#${grid.attr("id")}-sel-ct`).html(assets.length);
		// update selected count
	};
	[$("#image-grid"), $("#video-grid"), $("#document-grid")].forEach(grid => {
		grid.on("moved", function (item) {
			const thisCard = $(item.detail[1]);
			if (thisCard.hasClass("selected")) {
				const gridId = grid.attr("id");
				const srcType = gridId === "image-grid" ? "image" : gridId === "video-grid" ? "video" : "pdf";
				const assetType = srcType === "image" ? "images" : srcType === "video" ? "videos" : "docs";
				let thisAsset = editValues[assetType].find(asset => asset.id === thisCard.attr("data-id"));
				editValues[assetType] = editValues[assetType].filter(item => item.id != thisAsset.id);
				editValues[assetType].splice(thisCard.index(), 0, thisAsset);

				// remove asset, then re-add it in new location based on card index
			}
			updateSelected(grid);
		});
		updateSelected(grid);
	});

	$(".card-container").on("click", function () {
		const grid = $(this).parent();
		const gridId = grid.attr("id");
		const srcType = gridId === "image-grid" ? "image" : gridId === "video-grid" ? "video" : "pdf";
		const assetType = srcType === "image" ? "images" : srcType === "video" ? "videos" : "docs";
		const card = $(this);
		const assetId = card.attr("data-id");
		if (card.hasClass("selected")) {
			editValues[assetType] = editValues[assetType].filter(item => item.id != assetId);
			// remove asset from kit's array for this asset type

			card.removeClass("selected");
		} else {
			const selected = damAssets[srcType].find(item => item.id === assetId);
			editValues[assetType].push(selected);
			// add asset to kit's array for this asset type

			card.addClass("selected");
		}
		updateThumbPicker();
		updateSelected(grid);
	});
	// asset click handlers
	$(".asset-preview-btn").on("click", function (e) {
		e.stopImmediatePropagation();
		const type = $(this).attr("data-type");
		const src = damAssets[type].find(item => item.id === $(this).attr("data-id"));
		const srcData = {
			name: src.metadata.fields.newsroomDisplayName && src.metadata.fields.newsroomDisplayName.length ? src.metadata.fields.newsroomDisplayName[0] : src.filename
		};
		if (type === "video") {
			srcData.video = {
				player: {
					html: src.embeds.video_player.html
				}
			};
		} else if (type === "pdf") {
			srcData.document = {
				viewer: {
					html: src.embeds.document_html5_viewer.html
				}
			};
		} else if (type === "image") {
			srcData.preview = src.thumbnails["2048px"].url;
		}
		preview(type, srcData);
	});
	// asset preview button click handler

	// MARK: Asset filter
	let filterInputTimer;
	$(".asset-filter").on("input", function () {
		const filterInput = $(this);
		const assetType = filterInput.attr("data-type");
		// image | video | document

		if (filterInputTimer) {
			clearTimeout(filterInputTimer);
		}
		filterInputTimer = setTimeout(function () {
			const val = filterInput.val() ? filterInput.val().toLowerCase() : "";
			const assets = $(`#${assetType}-grid .card-container`);
			if (val) {
				assets.hide();
				assets
					.filter(function () {
						return $(this).text().toLowerCase().indexOf(val.toLowerCase()) > -1;
					})
					.show();
			} else {
				assets.show();
			}
		}, 300);
	});
	// DAM collections asset filter

	const selectedReleasesCont = $("#selected_releases_container").on("moved", function () {
		let newOrder = [];
		selectedReleasesCont.find(".release_option input").each(function () {
			newOrder.push(kit.langs[editLang].releases.find(item => item.id === $(this).val()));
		});
		kit.langs[editLang].releases = newOrder;
	});
	// reorder kit.langs[editLang].releases array if there's a re-sort;

	// MARK: updateHeadlineSelect
	const updateHeadlineSelect = searchTerms => {
		if (searchTerms) {
			terms = uniqueList(terms.concat(searchTerms));
		}
		const allReleasesCont = $("#all_releases_wrapper");
		const foundReleasesCont = $("#found_releases").html("");
		selectedReleasesCont.html("");
		const now = new Date().getTime();
		foundReleases.forEach(release => {
			if (kit.langs[editLang].releases.length && kit.langs[editLang].releases.find(item => item.id === release.id)) {
				// this kit has selected releases
				// and this found release is among them,
				// so need to put in the selected releases area
				selectedReleasesCont.append(`<div class="release_option">
                                    <input type="checkbox" name="${release.id}" value="${release.id}" class="uk-checkbox uk-margin-small-right" checked>
                                    <span class="release_headline${!release.status ? " inactive" : ""}${release.pubTime > now ? " unpublished" : ""}">${release.headline}</span>
                                </div>`);
			} else {
				foundReleasesCont.append(`<div class="release_option">
                                    <input type="checkbox" name="${release.id}" value="${release.id}" class="uk-checkbox uk-margin-small-right">
                                    <span class="release_headline${!release.status ? " inactive" : ""}${release.pubTime > now ? " unpublished" : ""}">${release.headline}</span>
                                </div>`);
			}
		});

		$("#release_count").html(terms.length ? ` (${foundReleasesCont.find(".release_option").length} available that match term${terms.length != 1 ? "s" : ""} ${terms.map(term => `<span class="bold">${term}</span>`).join(", ")}; <span class="pointer underline" id="clear_terms_button">clear terms</span>)` : "");
		// update release select label

		const relInputs = allReleasesCont.find("input");
		relInputs.on("change", function () {
			const thisInput = $(this);
			const thisOpt = thisInput.parents(".release_option");
			const id = thisInput.val();
			if ($(this).prop("checked")) {
				// this release is selected
				const release = foundReleases.find(release => release.id === id);
				if (release) {
					kit.langs[editLang].releases.push({ id: id });
					// put release ID in kit's releases array

					thisOpt.appendTo(selectedReleasesCont).find(".release_headline");
					selectedReleasesCont.parents("#selected_releases_wrapper").removeClass("hidden");
				}
			} else {
				// this release is deselected

				kit.langs[editLang].releases = kit.langs[editLang].releases.filter(item => item.id != id);
				// remove from this kit's selected releases

				thisOpt.find(".release_headline").removeClass("selected");
				// remove 'selected' class

				thisOpt.prependTo("#found_releases");
				// move item back to top of found_releases

				if (!selectedReleasesCont.html().length) {
					selectedReleasesCont.parents("#selected_releases_wrapper").addClass("hidden");
				}
			}
			updateThumbPicker();
			// update thumb picker every time selection changes
		});
		$("#release_select").removeClass("hidden");
		$("#release_search input[name='search']").on("input", function () {
			$(this).parents(".field").removeClass("error");
		});
		// show headline select container

		const clearTermsBtn = $("#clear_terms_button");
		if (clearTermsBtn.length) {
			clearTermsBtn.on("click", function () {
				foundReleases = foundReleases.filter(release => kit.langs[editLang].releases.find(item => item.id === release.id));
				// set releases array back to just those selected

				terms = [];
				searchTerms = [];
				$("#release_search input[name='search']").val("");
				// clear terms collectors and search input

				updateHeadlineSelect(searchTerms);
			});
		}
	};
	// end updateHeadlineSelect function

	// MARK: updateThumbPicker
	const updateThumbPicker = () => {
		const availableThumbs = [];
		const thumbPicker = $("#thumb_picker").html("");
		if (kit.langs[editLang].releases.length) {
			// releases have been selected

			kit.langs[editLang].releases.forEach(kitRel => {
				const release = foundReleases.find(item => item.id === kitRel.id);
				if (release.images && release.images.length) {
					release.images.forEach((image, index) => {
						if (!availableThumbs.find(item => item.url === image.preview)) {
							availableThumbs.push({
								url: image.preview,
								assetId: `${release.id}-${index}`,
								name: image.name ? image.name : image.filename
							});
						}
					});
				}
			});
		}
		// push any available release preview images to
		// availableThumbs array, if not already in it (based on URL)

		["images", "videos", "docs"].forEach(assetType => {
			if (kit.langs[editLang][assetType] && kit.langs[editLang][assetType].length) {
				// an asset of this type has been selected
				kit.langs[editLang][assetType].forEach(asset => {
					const damAsset = damAssets[assetType === "docs" ? "pdf" : assetType.replace(/s$/, "")].find(item => item.id === asset.id);
					// get asset from damAssets; this version will have fresh thumbnail URLs

					if (damAsset && damAsset.thumbnails["600px"].url && !availableThumbs.find(item => item.assetId === damAsset.id)) {
						availableThumbs.push({
							url: damAsset.thumbnails["600px"].url,
							assetId: asset.id,
							name: damAsset.metadata && damAsset.metadata.fields ? (damAsset.metadata.fields.newsroomDisplayName ? damAsset.metadata.fields.newsroomDisplayName : damAsset.filename) : damAsset.filename
						});
						if (kit.langs[editLang].thumb && kit.langs[editLang].thumb.assetId === damAsset.id) {
							kit.langs[editLang].thumb.url === damAsset.thumbnails["600px"].url;
						}
						// also, if updating thumb URL for selector,
						// update selected thumb URL if asset IDs match
					}
				});
			}
		});
		// add DAM asset thumbnail URLs to
		// availableThumbs array, if not already in it (based on asset ID)

		let selectedThumb = kit.langs[editLang].thumb;
		availableThumbs.forEach(thumb => {
			thumbPicker.append(
				`<div class="thumb_wrapper">
						<div class="uk-cover-container thumbpicker_thumb">
							<img data-name="${thumb.name ? thumb.name : thumb.url.split(".").pop()}" data-assetid="${thumb.assetId}"${selectedThumb && selectedThumb.assetId === thumb.assetId ? ` class="selected" ` : ""}uk-cover src="${thumb.url}"/>
						</div>
					</div>`
			);
		});
		const thumbImgs = thumbPicker.find(".thumbpicker_thumb img").on("click", function () {
			thumbImgs.not($(this)).removeClass("selected");
			if ($(this).hasClass("selected")) {
				$(this).removeClass("selected");
				kit.langs[editLang].thumb = "";
			} else {
				$(this).addClass("selected");
				kit.langs[editLang].thumb = {
					url: $(this).attr("src"),
					assetId: $(this).attr("data-assetid"),
					name: $(this).attr("data-name")
				};
			}
		});
		// thumbnail click handler;
	};
	// end updateThumbPicker function

	if (kit.langs[editLang].releases.length) {
		updateHeadlineSelect();
	}
	// normally release search triggers updateHeadlineSelect
	// but if we have prev. selected releases, we
	// call it from here

	updateThumbPicker();

	// MARK: Release search
	$("#release_search_button").on("click", async function (e) {
		const btn = $(this);
		e.preventDefault();
		if ($(this).siblings("input").val()) {
			let searchTerms = parseTerms($(this).siblings("input").val());
			let termValues = {};
			searchTerms.forEach((term, index) => {
				termValues[`:t${index + 1}`] = term.toLowerCase();
			});
			let termsFilter = `${searchTerms
				.map((term, index) => {
					let val = `:t${index + 1}`;
					return `contains (#text, ${val})`;
				})
				.join(" OR ")}`;
			// build value and filter strings for payload

			let params = {
				reqId: "60c30c77-a71a-4c4d-9ae6-3a73143c4a5e",
				type: "release",
				returnProps: "id, pubTime",
				filterAdd: `AND (${termsFilter})`,
				valuesAdd: termValues,
				namesAdd: {
					"#text": "text"
				}
			};
			$("#release_search").css("position", "relative").append(dimmer());
			try {
				const response = await fetchNews({ container: btn, size: 1 }, [], "", params, userLevel);
				response.data.sort((a, b) => {
					return a.pubTime < b.pubTime ? -1 : a.pubTime > b.putTime ? 1 : 0;
				});
				let startIndex = 0;
				let pages = [];
				while (response.data.slice(startIndex, startIndex + 25).length) {
					// there's data beyond current startIndex
					pages.push(response.data.slice(startIndex, startIndex + 25));
					startIndex = startIndex + 25;
				}
				for (let i = 0; i < pages.length; i++) {
					try {
						const response = await fetchItems(pages[i], "release", btn, admin);
						const relBatch = response.sort((a, b) => {
							a = a.langs[lang].pubTime;
							b = b.langs[lang].pubTime;
							return a < b ? 1 : a > b ? -1 : 0;
						});
						relBatch.forEach(item => {
							for (let lang in item.langs) {
								if (!foundReleases.length || !foundReleases.find(_item => _item.id === item.id)) {
									// put found releases in foundReleases array, but
									// only if they're not already there

									foundReleases.push({
										headline: item.langs[lang].headline,
										pubTime: item.langs[lang].pubTime,
										images: item.langs[lang].images,
										id: item.id,
										status: item.langs[lang].status
									});
								}
							}
						});
					} catch (err) {
						notify("Error fetching releases", "danger");
						console.error(err);
					}
				}
				// fetch actual releases, 25 at a time

				$(".dimmer").remove();
				foundReleases.sort((a, b) => {
					if (a.pubTime < b.pubTime) {
						return 1;
					} else if (a.pubTime > b.pubTime) {
						return -1;
					}
					return 0;
				});
				// sort releases by pubTime

				updateHeadlineSelect(searchTerms);
				// helper function places search results
				// in select dropdown
			} catch (err) {
				console.error("Error fetching releases");
				console.error(err);
			}
		}
	});

	$(".flatpickr-calendar").remove();
	// get rid of any existing flatpickr calendars hanging around

	flatpickr("[name='pubTime']", {
		altInput: true,
		altFormat: "F j, Y at h:iK",
		dateFormat: "U",
		defaultDate: id ? pubTime : now,
		enableTime: true
	});

	$("[name='status']").prop("checked", editValues.status ? editValues.status : false);
	// update misc other form settings from incoming data

	$(`[name='name']`).on("input", function () {
		$(this).parents(".field").removeClass("error");
	});
	$("#submitkitButton").on("click", function (e) {
		e.preventDefault();
		processKit(id, author, kit, cb);
	});
	// submit form click handler

	// MARK: Delete kit handler
	if (id) {
		$("#deletekitButton").on("click", async function (e) {
			const delBtn = $(this).css({ position: "relatiave" });
			e.preventDefault();
			try {
				await cModal(`<h3>Just checking ...</h3>
					<div>You are about to delete "${editValues.name}" for ALL languages. If you wish to only to remove it for a particular language, toggle its "Status" off using its admin panel in the kits list, or switch to that language in this kit editor and change its status to "inactive". Otherwise, confirm the deletion below:</div>`);

				notify(`Deleting kit "${editValues.name}" <span uk-spinner></span>`, "primary", "top-right", 3000, "release delete", true);
				const params = {
					reqId: "f7ace6c3-dc2b-47f4-9f08-b890a61739ea",
					id: id,
					datatype: "kit"
				};
				try {
					await request(params, delBtn);
					notify(`Kit "${editValues.name}" successfully deleted`, "success");
					$("#kits_grid").find(`[data-id='${id}']`).remove();
					kits = kits.filter(item => item.id != id);
					// update DOM and in-memory kits array with a removal;

					kitButton.trigger("click");
					// remove editor

					if (cb) {
						cb(kits);
					}
				} catch (err) {
					notify("There was an error deleting this kit", "danger");
					console.error(err);
				}
			} catch (err) {
				console.error(err);
				notify(`There was an error: ${err}`, "danger", "top-right", 3000, "release delete", true);
			}
		});
	}
	// delete kit click handler (if id exists)
};
// end buildKitEditor function

// MARK: Process kit
const processKit = async (id, author, kit, cb) => {
	let form = $("#kit_form");
	form.find(".error").removeClass("error");

	let editLang = "en";
	if (!id) {
		kit.id = self.crypto.randomUUID();
	}
	const values = kit.langs[editLang];
	values.updated = new Date().getTime();
	values.name = form.find("[name='name']").val();
	values.created = id ? kit.langs[editLang].created : parseInt($("[name='createdReadable']").attr("data-timestamp"));
	values.pubTime = parseInt($("[name='pubTime']").val()) * 1000;
	values.status = $("[name='status']").prop("checked");
	values.updatedBy = author;
	// updates from form

	let valid = true;
	let reqFields = ["name"];
	if (values.status) {
		reqFields.push("thumb");
		if (!values.releases.length && !values.docs.length && !values.images.length && !values.videos.length) {
			reqFields = reqFields.concat(["releases", "docs", "images", "videos"]);
		}
	}
	reqFields.forEach(field => {
		if (!values[field]) {
			valid = false;
		} else {
			const fieldType = typeof values[field] === "string" ? "string" : typeof values[field] === "object" ? (Array.isArray(values[field]) ? "array" : "object") : "string";
			switch (fieldType) {
				case "string":
					// no op
					break;
				case "array":
					valid = !!values[field].length;
					break;
				case "object":
					valid = !!Object.keys(values[field]).length;
			}
		}
		if (!valid) {
			$(`[field='${field}']`).addClass("error");
		}
	});
	if (valid) {
		// no validation errors; let's confirm kit submission

		let msgTime = humanDate(values.pubTime, true, " at ");
		let previewBody = values.pubTime <= new Date().getTime() ? `This kit's publish date (<span class="bold">${msgTime}</span>) is current or past so it will publish <span class="bold">immediately</span>.` : `This kit's publish date (<span class="bold">${msgTime}</span>) is in the future, so it will <span class="bold">not</span> publish until then.`;
		previewBody = `${previewBody} Its status is <span class="bold">${values.status ? "Active" : "Inactive"}</span>.`;

		try {
			console.log("thumb:", values);
			await cModal(`<h3>Just checking ...</h3>
			<div>${previewBody}<p class="bold">Is this the plan?</p></div>`);
			if (values.thumb.url.indexOf("sig.expires") > -1) {
				// DAM thumb URLs expire, so
				// let's upload this to a permanent location

				const response = await $.ajax({
					method: "GET",
					url: values.thumb.url,
					xhrFields: {
						responseType: "blob"
					}
				});
				const imageData = new File([response], values.thumb.name, { type: response.type });
				const filename = `${imageData.name
					.replace(/[\s\+]/g, "-")
					.replace(/%/g, "-percent")
					.replace(/[^-._a-zA-Z0-9]/g, "")
					.replace(/-+/g, "-")}.${response.type.split("/").pop()}`;
				try {
					const key = `images/thumbnails/${filename}`;
					const formData = new FormData();
					const params = {
						reqId: "2273c810-4746-4461-bca7-451c7b8ffecc",
						// formDataUploadToS3Pvt
						env: status,
						bucket: s3bucket,
						key: key,
						storage: "INTELLIGENT_TIERING",
						cacheControl: "public, max-age=300",
						contentType: imageData.type,
						tagging: `dmSite=Gulfstream News&Project=Kit Manager&Name=${key}`
					};
					for (let prop in params) {
						formData.append(prop, params[prop]);
					}
					formData.append("file", imageData);
					notify(`Uploading thumbnail ${filename} ...`);
					const response = await binaryUpload(formData, form);
					if (response.success) {
						values.thumb.url = `${assetHost}/${key}`;
						// reset thumb URL to new location;
						// the thumb assetID will still point
						// back to its source asset
					} else throw response.data;
				} catch (err) {
					notify("Error uploading kit thumbnail", err);
					console.error(err);
				}
			}
			if (values.images && values.images.length > 1) {
				notify("Generating related photos archive");
				try {
					const zipKey = `data-service/data/zip/${values.name
						.toLowerCase()
						.replace(/\s/g, "-")
						.replace(/(\(|\))/g, "")}-media-kit-images.zip`;
					const response = await request(
						{
							reqId: "08b18516-0277-4c6d-a5ab-1e09d5fc7b91",
							// Zipper
							sourceURLs: values.images.map(item => ({
								url: item.embeds.original.url,
								name: item.metadata && item.metadata.fields && item.metadata.fields.newsroomDisplayName && item.metadata.fields.newsroomDisplayName.length ? `${item.metadata.fields.newsroomDisplayName[0]}.${item.filename.split(".").pop()}` : item.filename
							})),
							zipKey: zipKey,
							origin: location.origin
						},
						$(this)
					);
					values.imageArchive = response;
					await request({
						reqId: "b74ffd7d-f6af-47be-92fc-aeb2eec16348",
						// newsroomPurgeAssetsCachePvt
						timestamp: new Date().getTime(),
						pathCount: 1,
						paths: [`/${zipKey}`]
					});
				} catch (err) {
					console.error(err);
					notify("Error generating image archive", "danger");
				}
			}
			const indexedKits = [];
			if (!id) {
				for (let lang in kit.langs) {
					kit.langs[lang].id = kit.id;
				}
				kits.unshift(kit);
				kits.forEach((kit, index) => {
					for (let lang in kit.langs) {
						kit.langs[lang].sortIndex = index;
						//
					}
					indexedKits.push({
						PutRequest: {
							Item: kit
						}
					});
				});
			}
			// add new kit to start of kits array and re-index all for sorting

			const params = id
				? {
						// this is an edit, so we're upserting values of
						// this single kit via data service batchWrite

						reqId: "4b9d14f5-1255-4f03-8b6a-da2363fe25ee",
						data: [
							{
								PutRequest: {
									Item: kit
								}
							}
						]
				  }
				: {
						// this is a new kit, so we're batch writing all
						// kits with their new sortIndex values
						reqId: "4b9d14f5-1255-4f03-8b6a-da2363fe25ee",
						data: indexedKits
				  };

			notify(`Saving media kit to database ...`);
			try {
				await request(params, form);
				notify("Media kit successfully saved", "success");
				$("#createKitButton").trigger("click");
				if (cb) {
					cb(kits);
				}
				// fire callback if one is passed in
			} catch (err) {
				console.error(err);
				notify("There was an error saving your form.", "danger");
			}
		} catch (err) {
			if (err) {
				console.error(err);
			}
		}
	}
	// form passed validation
};
// end processKit function
